<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "ChannelForwardConfigUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            const channelType = this.$_.get(this.activity, "payload.type");
            let channelTypeName = channelType;
            if (channelType === "facebook") channelTypeName = "Facebook";
            else if (channelType === "instagram") channelTypeName = "Instagram";
            else if (channelType === "instagram-v2") channelTypeName = "Instagram V2";
            else if (channelType === "whatsapp") channelTypeName = "WhatsApp";
            else if (channelType === "telegram") channelTypeName = "Telegram";
            else if (channelType === "web") channelTypeName = "Web";
            
            return this.$t('notification.channelForwardConfigUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                channelName: this.$_.get(this.activity, 'payload.name'),
                channelType: channelTypeName
            });
        }
    }
};
</script>

